import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectAccessToken } from '../../../slices/staffSlice';
import { Topbar, Sidebar, Loader, Pagination } from "../../../components";
import { fetchRequests } from "../../../Requests/getRequests";
import { authStaff } from '../../../utils/constants';
import { useDispatch } from 'react-redux';
import { show } from '../../../slices/toastSlice';
import Permission from './Permission';
import { HugeiconsIcon } from '@hugeicons/react';
import { CheckmarkCircle01Icon } from '@hugeicons/core-free-icons';

function Index() {

    const accessToken = useSelector(selectAccessToken);
    const dispatch = useDispatch();
    const [permissions, setPermissions] = useState();
    const [loader, setLoader] = useState(true);

    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(10);
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = permissions?.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil((permissions?.length || 0) / recordsPerPage);

    useEffect(() => {
        let unsubscribed = false;
        const load = async () => {
            const res = await fetchRequests(`/auth/roles/permissions`, "GET", authStaff(accessToken), {}, {});
            if (!unsubscribed) {
                if (res?.code === 401 || res?.code === "AuthenticationFailedError") {
                    dispatch(show({ type: "error", state: true, message: "Your session has expired" }));
                } else {
                    setLoader(false);
                    setPermissions(res?.permissions || res);
                }
            }
        };
        load();
        return () => { unsubscribed = true; };
    }, [accessToken, dispatch]);

    return (
        <div className="main-container">
            <Topbar />
            <Sidebar />

            <main className="main-content">
                <section className="section-container space-y-6">

                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <div className="w-9 h-9 rounded-xl bg-emerald-50 border border-emerald-100 flex items-center justify-center shrink-0">
                                <HugeiconsIcon icon={CheckmarkCircle01Icon} size={18} className="text-emerald-600" />
                            </div>
                            <div>
                                <div className="flex items-center gap-2">
                                    <h1 className="text-lg font-semibold text-gray-900 dark:text-gray-50">Permissions</h1>
                                    {permissions?.length > 0 && (
                                        <span className="px-2 py-0.5 text-xs font-medium bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400 rounded-full">
                                            {permissions.length}
                                        </span>
                                    )}
                                    {loader && <Loader color="text-gray-400" size="w-4 h-4" />}
                                </div>
                                <p className="text-sm text-gray-400">System permissions available for roles</p>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm overflow-hidden">
                        <table className="min-w-full">
                            <thead>
                                <tr className="bg-gray-50/60 dark:bg-gray-900/60 border-b border-gray-100 dark:border-gray-700">
                                    <th className="px-5 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide w-[25%]">Name</th>
                                    <th className="px-5 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide w-[40%]">Description</th>
                                    <th className="px-5 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Slug</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-50 dark:divide-gray-700/50">
                                {currentRecords ? (
                                    currentRecords.length > 0 ? (
                                        currentRecords.map((item, index) => (
                                            <Permission key={index} item={item} />
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="3" className="px-5 py-12 text-center text-sm text-gray-400">
                                                No permissions found
                                            </td>
                                        </tr>
                                    )
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="px-5 py-12 text-center">
                                            <Loader color="text-gray-400" size="w-5 h-5" />
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        {currentRecords && (
                            <Pagination
                                nPages={nPages}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                length={permissions?.length}
                            />
                        )}
                    </div>

                </section>
            </main>
        </div>
    );
}

export default Index;
